import React from "react";
import { RotateCcw, Gem, Headset, ArrowRight } from "lucide-react";
import { SOCIALS } from "../mock";

const benefits = [
  {
    Icon: RotateCcw,
    title: "Rolling Lossback",
    desc: "Get a share of your losses back automatically, rolling every single day.",
  },
  {
    Icon: Gem,
    title: "Exclusive Rewards",
    desc: "Unlock bonuses, drops and perks reserved only for the Broer VIP community.",
  },
  {
    Icon: Headset,
    title: "Personal Account Manager",
    desc: "Your own Roobet account manager, available 24/7 to help you out.",
  },
];

const VipTransfer = () => {
  return (
    <section id="vip-transfer" className="relative py-24 px-5 bg-[#2f2753]">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-3xl border border-[#edbb23]/40 bg-[#342b60] overflow-hidden">
          {/* gold top accent */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-[#edbb23]" />

          <div className="px-6 md:px-12 py-12">
            <div className="flex flex-col items-center text-center">
              <img src="/assets/roobet-chip.png" alt="" className="h-20 w-20 object-contain mb-5" />
              <p className="text-[#edbb23] font-extrabold tracking-[0.3em] text-sm mb-3">EXCLUSIVE</p>
              <h2 className="text-4xl md:text-5xl font-black text-white tracking-tight">VIP Transfer</h2>
              <p className="mt-5 text-[#b7b0d6] max-w-2xl leading-relaxed">
                Already a VIP somewhere else? Currently playing (or played in the past) on
                <span className="text-white font-semibold"> Stake, Rainbet, Shuffle</span> or another casino? Transfer your
                VIP status over to Roobet with code <span className="text-[#edbb23] font-bold">BROER</span> and keep all the
                progress you built up — don't lose what you've earned.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-5 mt-10">
              {benefits.map((b) => (
                <div key={b.title} className="rounded-2xl bg-[#251e44] border border-[#473c7d] p-6 text-center transition-all duration-300 hover:border-[#edbb23]/50 hover:-translate-y-1">
                  <div className="mx-auto mb-4 w-14 h-14 rounded-xl bg-[#edbb23] flex items-center justify-center text-[#251e44]">
                    <b.Icon size={26} />
                  </div>
                  <h3 className="text-lg font-extrabold text-white mb-2">{b.title}</h3>
                  <p className="text-sm text-[#b7b0d6] leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-col items-center gap-3">
              <a
                href={SOCIALS.discord}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#edbb23] hover:bg-[#f4cf52] text-[#251e44] font-extrabold rounded-xl px-8 h-14 transition-colors"
              >
                <img src="/assets/roobet-dark.png" alt="" className="w-5 h-5 object-contain" />
                VIP TRANSFER
                <ArrowRight size={18} />
              </a>
              <p className="text-xs text-[#8f88b8]">Opens a VIP Transfer ticket in our Discord</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VipTransfer;
